import React from 'react';

/**
 * Inline, muted, autoplaying, looping <video> — a drop-in replacement for an
 * animated-GIF `<img>`. Pass through the same `className` the <img> used so it
 * inherits the existing sizing/layout. VP9 WebM is preferred, H.264 MP4 is the
 * Safari/iOS fallback.
 *
 *   import tvWebm from 'url:.../onProperyTVImageGuestRoom.webm';
 *   import tvMp4  from 'url:.../onProperyTVImageGuestRoom.mp4';
 *   <LoopingVideo webm={tvWebm} mp4={tvMp4} className='guest-room-tv' />
 */
const LoopingVideo = ({ webm, mp4, poster, className = '', ...rest }) => {
  return (
    <video
      className={className}
      autoPlay
      loop
      muted
      playsInline
      preload='auto'
      poster={poster}
      aria-hidden='true'
      {...rest}
    >
      {webm && <source src={webm} type='video/webm' />}
      {mp4 && <source src={mp4} type='video/mp4' />}
    </video>
  );
};

export default LoopingVideo;
